<template>
  <div :class="{ 'submitting': deleting }">
    <a-icon v-if="deleting" class="spinner" type="loading" />
    <p>
      Your subscription will be gone forever so be extra sure you want to permanently delete this.
    </p>
    <div class='form-row button-footer'>
      <button class='flat-button' @click.prevent="cancelDeleteSubscription">Cancel</button>
      <button class='raised-button' @click.prevent="deleteAndClose" :disabled='deleting'>Delete subscription</button>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex'

  export default {
    name: "ConfirmDeleteSubscription",
    data() {
      return {}
    },
    methods: {
      deleteAndClose() {
        this.destroySubscription(this.id)
      },
      ...mapActions('subscriptions', ['destroySubscription']),
      ...mapMutations('subscriptions', ['cancelDeleteSubscription'])
    },
    computed: {
      ...mapState('subscriptions', {id: 'deleteSubscriptionId', deleting: 'deleting'})
    }
  }
</script>

<style scoped lang="stylus">
@import '../styles/buttons'
.button-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
</style>